<template>
  <div>
    <div v-for="announcement in list" :key="announcement.id">
      <alert v-if="shouldShow(announcement)"
             :type="announcement.type_name.toLowerCase()"
             :icon="resolveIcon(announcement.type_name)"
      >
        <span v-html="announcement.translate"></span>
      </alert>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Alert from "@components/UIComponents/Alert";

export default {
  name: "AnnouncementListener",
  components: {Alert},
  data() {
    return {};
  },
  computed: {
    ...mapGetters("announcementStore", ["list"]),
    ...mapGetters("userStore", {user: "user"}),
    ...mapGetters("companyStore", {company: "currentCompany"}),
  },
  async mounted() {
    try {
      this.getList();
    } catch (error) {
      return;
    } finally {
      return;
    }
  },
  methods: {
    ...mapActions("announcementStore", ["getList"]),
    resolveIcon(type) {
      switch (type) {
        case "PRIMARY":
          return "far fa-exclamation-circle";
        case "SECONDARY":
          return "far fa-exclamation-circle";
        case "SUCCESS":
          return "far fa-check-circle";
        case "DANGER":
          return "far fa-times-circle";
        case "WARNING":
          return "far fa-exclamation-triangle";
        case "INFO":
          return "far fa-exclamation-circle";
        case "LIGHT":
          return "far fa-exclamation-circle";
        case "DARK":
          return "far fa-exclamation-circle";
        default:
          return "far fa-exclamation-circle";
      }
    },
    shouldShow(announcement) {
      if (!announcement.company_list.length) {
        return true;
      }

      const company = this.company;

      let shouldShow = false;

      announcement.company_list.map((announcementCompany) => {
        if (company.id !== announcementCompany.id) {
          return;
        }
        shouldShow = true;
        return;
      });

      return shouldShow;
    }
  },
};
</script>

<style lang="scss" scoped>
.alert {
  font-size: 1.1em;
  padding: 15px;
  margin-bottom: 20px;
}

.alert .icon-big {
  margin-right: 8px;
  font-size: 1.5em;
}
</style>
